















import { Component, Mixins, Prop } from 'vue-property-decorator'
import CoresDoPainel from './CoresDoPainel'
import type { BlocoDeBagsECrediario } from '@/shareds/painel-do-cliente-bags-shareds'
import { TEXTO_SEM_DADOS } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class BlocoDeBagsECrediarioDoPainel extends Mixins(CoresDoPainel) {
	@Prop({ type: Object, required: true }) bloco!: BlocoDeBagsECrediario

	get corDoValor() {
		if (!this.bloco.cor || this.bloco.valor === TEXTO_SEM_DADOS) return null
		return this.corLegivel(this.bloco.cor)
	}
}
